import { getErrorMessage } from "@/core/api/helpers"
import { useAppDispatch } from "@/redux/hooks"
import { useAddUserDNCMutation } from "@/redux/services/userDncApi"
import { setToast } from "@/redux/toastSlice"

export const useUserAddDNC = () => {
  const dispatch = useAppDispatch()
  const [addUserDNC, response] = useAddUserDNCMutation()

  const handleAddUserDNC = async ({
    body,
    id,
  }: {
    body: { records: string[] }
    id: string
  }) => {
    try {
      const response = await addUserDNC({ body, id }).unwrap()
      if (response) {
        dispatch(
          setToast({
            show: true,
            variant: "success",
            message: "Success add contact",
          }),
        )
      }
    } catch (error: any) {
      const message = getErrorMessage(error)
      dispatch(
        setToast({
          show: true,
          variant: "error",
          message,
        }),
      )
      throw new Error(message)
    }
  }

  return { addUserDNC: handleAddUserDNC, response }
}
